(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.azn_dragScrollInitialized) return;
    window.azn_dragScrollInitialized = true;

    var azn_activeGrid = null;
    var azn_startX = 0;
    var azn_startScroll = 0;
    var azn_moved = 0;

    document.addEventListener('pointerdown', function (event) {
      if (event.button !== 0 || event.pointerType !== 'mouse') return;
      var grid = event.target.closest('[data-azn-drag-scroll]');
      if (!grid || grid.scrollWidth <= grid.clientWidth) return;

      azn_activeGrid = grid;
      azn_startX = event.clientX;
      azn_startScroll = grid.scrollLeft;
      azn_moved = 0;
    });

    document.addEventListener('pointermove', function (event) {
      if (!azn_activeGrid) return;
      var delta = event.clientX - azn_startX;
      if (Math.abs(delta) > 3) {
        azn_moved = Math.abs(delta);
        azn_activeGrid.classList.add('is-dragging');
        azn_activeGrid.scrollLeft = azn_startScroll - delta;
        event.preventDefault();
      }
    });

    function azn_endDrag() {
      if (!azn_activeGrid) return;
      azn_activeGrid.classList.remove('is-dragging');
      azn_activeGrid = null;
    }

    document.addEventListener('pointerup', azn_endDrag);
    document.addEventListener('pointercancel', azn_endDrag);

    document.addEventListener(
      'click',
      function (event) {
        if (azn_moved > 5 && event.target.closest('[data-azn-drag-scroll]')) {
          event.preventDefault();
          event.stopPropagation();
        }
        azn_moved = 0;
      },
      true
    );

    document.addEventListener(
      'wheel',
      function (event) {
        var grid = event.target.closest('[data-azn-drag-scroll]');
        if (!grid || event.ctrlKey) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        if (grid.scrollWidth <= grid.clientWidth) return;
        grid.scrollLeft += event.deltaY;
        event.preventDefault();
      },
      { passive: false }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
